import homeConf from './config/home-config.json'

export interface Conf  {
    uiStart: string;
    url: string;
    baseurl: string;
    authUrl: string;
    videoUrl: string;
    socketVideoUrl: string;
    socketUrl: string;
    homeUrl: string;
    timer: number;
}

export const config: Conf = homeConf;

